export default __webpack_public_path__ + "static/media/logo.0537929f.png";